import { PageController } from '@client/components/_core/layout/PageController';
import { IntakeWizard } from '@client/components/intake/IntakeWizard';
import { getFlag } from '@client/utils/feature-flags';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/intake')({
    staticData: {
        metadata: {
            title: 'Smart intake',
        },
        ui: {
            widthVariant: 'compact',
            className: 'w-6xl max-w-full',
        },
    },
    // Defence-in-depth: the entry points are flag-gated and `intake.triage`
    // returns NOT_FOUND when off; bounce a direct visit at the router level.
    // Convention is beforeLoad + throw redirect (not <Navigate>).
    beforeLoad: async ({ params }): Promise<void> => {
        const enabled = await getFlag('enable-ai-intake', false);
        if (!enabled) {
            throw redirect({
                to: '/console/$orgId/compliance/complaints',
                params: { orgId: params.orgId },
                replace: true,
            });
        }
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <IntakeWizard />
        </PageController>
    );
}
